
import {GameModeTranslationKeyContext} from '@colonist/i18n'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameEndTabButtonsView} from '../../../../shared/scripts/ui_game/ui_game_end_screen/GameEndTabButtonsView'
import {UIGameEndChartView} from '../../../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndChartView'
import {UIGameEndStatsController} from '../../../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndStatsController'

export class UITGameEndStatsController extends UIGameEndStatsController {
    protected buildTabs(gameModeTranslationKeyContext: GameModeTranslationKeyContext) {
        this.tabButtonsView = new UIGameEndTabButtonsView(0, 0, this.container.width, this.itemSize, 6, this.container, this, gameModeTranslationKeyContext)
        this.tabButtonsView.createOverviewTab()
        this.tabButtonsView.createDiceStatsTab()
        this.tabButtonsView.createResourceCardStatsTab()
        this.tabButtonsView.createDevCardStatsTab()
        this.tabButtonsView.createActivityStatsTab()
        this.tabButtonsView.createResourceStatsTab()

        this.createStatsView()
        this.createTableTabs()
        this.createCharts()
    }

    private createCharts() {
        const widthOccupiedByVP = this.itemSize
        const w = this.statsView.horizontalScrollBox.contentWidth - widthOccupiedByVP
        const h = this.statsView.verticalScrollBox.contentHeight
        const container = this.statsView.horizontalScrollBox.content
        this.chartContainer = new SectionBgView(widthOccupiedByVP, 0, w, h, container)
        this.createChartTabs()
    }

    override showActiveView() {
        super.showActiveView()

        if(this.activeTab.container instanceof UIGameEndChartView) {
            this.tableHeadView.hideHeaders()
            return
        }
        if(this.activeTab.button == this.tabButtonsView.overView) {
            this.tableHeadView.showOverviewHeader()
        } else if(this.activeTab.button == this.tabButtonsView.resourceStats) {
            this.tableHeadView.showResourceStatsHeader()
        } else if(this.activeTab.button == this.tabButtonsView.activityStats) {
            this.tableHeadView.showActivityStatsHeader()
        }

        this.statsView.updateHorizontalScrollbox()
    }

    protected override hideAll() {
        super.hideAll()
        this.tableHeadView.hideHeaders()
    }
}
